import React from 'react'
import './Appsection5.css'
import s51 from './../../../Assets/images/app5/s5-1.png'
import s52 from './../../../Assets/images/app5/s5-2.png'
import s53 from './../../../Assets/images/app5/s5-3.png'
import s54 from './../../../Assets/images/app5/s5-4.png'
import s55 from './../../../Assets/images/app5/s5-5.png'
import s56 from './../../../Assets/images/app5/s5-6.png'
import s57 from './../../../Assets/images/app5/s5-7.png'
import s58 from './../../../Assets/images/app5/s5-8.png'
import s59 from './../../../Assets/images/app5/s5-9.png'
import s510 from './../../../Assets/images/app5/s5-10.png'
import s511 from './../../../Assets/images/app5/s5-11.png'
import s512 from './../../../Assets/images/app5/s5-12.png'
import s513 from './../../../Assets/images/app5/s5-13.png'
import s514 from './../../../Assets/images/app5/s5-14.png'
import s515 from './../../../Assets/images/app5/s5-15.png'

import dotright from './../../../Assets/images/DotRight.webp'
export default function Appsection5() {
  return (
    <section className='appsection5'>
        <section className='appsection5__top'>
        <h5>لورم ایپسوم متن</h5>
        <h2>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم</h2>
      </section>
      <section className='appsection5__middle1'>
            <section className='appsection5__middle1__right'>
                <div className='appsection5__middle1__right__title'>
                    <p>۱</p>
                    <h3>لورم ایپسوم</h3>
                </div>
                <p className='appsection5__middle1__right__text'>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد
                </p>
                <ul className='appsection5__middle1__right__item'>
                    <p> لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ :</p>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                </ul>
            </section>
            <section className='appsection5__middle1__left'>
                <div className="appsection5__middle1__left__top">
                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s51} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s52} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s53} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                </div>
                <div className="appsection5__middle1__left__bottom">
                <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s54} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s55} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>
                    <section className="appsection5__dotright">
                        <img src={dotright} alt="" />
                    </section>
                </div>
            </section>
      </section>


      <section className='appsection5__middle1 appsection5__middle2'>
            <section className='appsection5__middle1__right'>
                <div className='appsection5__middle1__right__title'>
                    <p>۲</p>
                    <h3>لورم ایپسوم</h3>
                </div>
                <p className='appsection5__middle1__right__text'>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد
                </p>
                <ul className='appsection5__middle1__right__item'>
                    <p> لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ :</p>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                </ul>
            </section>
            <section className='appsection5__middle1__left'>
                <div className="appsection5__middle1__left__top">
                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s51} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s56} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s57} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                </div>

                <div className="appsection5__middle1__left__top appsection5__middle1__left__top2">
                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s58} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s59} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s510} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                </div>
                <div className="appsection5__middle1__left__bottom">
                <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s511} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s512} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>
                    <section className="appsection5__dotright">
                        <img src={dotright} alt="" />
                    </section>
                </div>
            </section>
      </section>

      <section className='appsection5__middle1'>
            <section className='appsection5__middle1__right'>
                <div className='appsection5__middle1__right__title'>
                    <p>۳</p>
                    <h3>لورم ایپسوم</h3>
                </div>
                <p className='appsection5__middle1__right__text'>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد
                </p>
                <ul className='appsection5__middle1__right__item'>
                    <p> لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ :</p>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                    <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ</li>
                </ul>
            </section>
            <section className='appsection5__middle1__left'>
                <div className="appsection5__middle1__left__top">
                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s51} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s513} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s514} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                </div>
                <div className="appsection5__middle1__left__bottom">
                <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s57} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>

                    <div className="appsection5__middle1__left__top__item">
                        <div className="appsection5__middle1__left__top__item__item">
                            <div className="appsection5__middle1__left__top__item__item__image">
                                <img src={s515} alt="" />
                            </div>
                            <small>لورم ایپسوم </small>
                        </div>
                    </div>
                    <section className="appsection5__dotright">
                        <img src={dotright} alt="" />
                    </section>
                </div>
            </section>
      </section>
    </section>
  )
}
